// extracted by mini-css-extract-plugin
module.exports = {"review-dialog":"review-dialog-47ba406ca3b326a7d38b61307f8dacc7","el-dialog__body":"el-dialog__body-8a00b80032fd77e348bd857c020a48d0"};